import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'database-blank-object-experience.templates-button': {
    id: 'database-blank-object-experience.templates-button',
    defaultMessage: 'Templates',
    description:
      'The text for a button in the database blank object experience that opens database templates.'
  }
});
